/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * hilo-oauth-manager
 * CategoryAdapter.tsx
 */

import ListAdapter, {AdapterListener} from "../../tools/list/ListAdapter";
import Category from "../../models/Category";
import React from "react";
import {Column} from "../../tools/list/Column"
import Translation from "../../services/translation/Translation";
import CategoryDataProvider from "../../provider/CategoryDataProvider";
import {CategoryAPIPagination} from "../../pagination/CategoryAPIPagination";

export interface CategoryAdapterListener extends AdapterListener<Category> {
}

export default class CategoryAdapter extends ListAdapter<Category, CategoryAdapterListener, CategoryAPIPagination> {
    private _t: Translation;

    /**
     * constructor
     * @param categorysProvider
     * @param listener
     * @param t
     */
    constructor(t: Translation, categorysProvider: CategoryDataProvider, listener?: CategoryAdapterListener) {
        super();

        this._t = t;
        this.addColumn(new Column(t.categoryListColID, "id", this._id));
        this.addColumn(new Column(t.categoryListColTitle, "title", this._title));
        this.addColumn(new Column(t.position, "order", this._order));

        this.init(
            t.categoryListEmpty,
            categorysProvider,
            [],
            listener
        );
    }

    /**
     * _id
     * @returns {any}
     * @private
     * @param category
     */
    private _id = (category: Category): JSX.Element => {
        return <p className={"blue-hover"}>{category.id}</p>
    };

    /**
     * _title
     * @returns {any}
     * @private
     * @param category
     */
    private _title = (category: Category): JSX.Element => {
        return <p className={"blue-hover"}>{category.title}</p>
    };

    /**
     * _order
     * @returns {any}
     * @private
     * @param category
     */
    private _order = (category: Category): JSX.Element => {
        return <p className={"blue-hover"}>{category.order}</p>
    };
}